module.exports = __webpack_public_path__ + "static/media/poloniex.3682f4a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/exchanges/poloniex.png
// module id = 105
// module chunks = 0